export default "__VITE_ASSET__BUDewxvS__"